/**
 * <jj-review-marquee> makes a row of review cards glide continuously.
 * It clones the list once (hidden from assistive tech and keyboard) so the loop is seamless;
 * the CSS animation pauses on hover/focus and is disabled for reduced-motion users.
 */
class JJReviewMarquee extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('[data-rv-track]');
    const list = track?.querySelector('[data-rv-list]');
    if (!track || !list || track.querySelector('[data-rv-clone]')) return;
    const clone = /** @type {HTMLElement} */ (list.cloneNode(true));
    clone.setAttribute('data-rv-clone', '');
    clone.setAttribute('aria-hidden', 'true');
    clone.inert = true;
    clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
    track.append(clone);
    this.setAttribute('data-ready', '');
  }
}
if (!customElements.get('jj-review-marquee')) customElements.define('jj-review-marquee', JJReviewMarquee);
